import {
  Outlet,
  createFileRoute,
  useRouteContext,
} from '@tanstack/react-router'

import { AppLayout } from '@/components/AppLayout'
import { GxpSignatureProvider } from '@/components/GxpSignatureDialog'
import { useGlobalEventsSubscription } from '@/hooks/useGlobalEventsSubscription'
import { useUnresolvedSummary } from '@/hooks/useUnresolvedSummary'

export const Route = createFileRoute('/_app')({
  component: RouteComponent,
})

function RouteComponent() {
  useGlobalEventsSubscription()
  useUnresolvedSummary()
  const { pinStatus } = useRouteContext({ from: '__root__' })

  return (
    <GxpSignatureProvider>
      <AppLayout pinStatus={pinStatus}>
        <Outlet />
      </AppLayout>
    </GxpSignatureProvider>
  )
}
